var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "98px",
    height: "59px",
    viewBox: "0 0 980.000000 592.000000",
    preserveAspectRatio: "xMidYMid meet",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,592.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4515 5904 c-872 -67 -1659 -287 -2411 -673 -792 -407 -1461 -965 -1830 -1526 -121 -184 -196 -342 -246 -520 -32 -113 -32 -304 0 -423 88 -327 314 -680 667 -1041 1097 -1124 2797 -1780 4432 -1711 478 20 833 72 1288 187 1281 323 2502 1121 3097 2023 185 280 288 551 288 755 0 395 -345 965 -875 1446 -902 817 -2088 1327 -3405 1465 -147 15 -871 28 -1005 18z m785 -542 c241 -46 413 -102 626 -207 393 -192 709 -475 947 -848 561 -876 502 -2055 -143 -2865 -99 -124 -242 -271 -353 -361 -343 -279 -784 -463 -1219 -510 -141 -16 -409 -13 -545 4 -431 57 -848 236 -1178 507 -96 79 -271 255 -350 353 -269 333 -453 754 -515 1178 -76 513 10 1039 242 1496 337 661 969 1130 1688 1251 170 29 164 28 440 25 202 -3 277 -8 360 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4754 4500 c-445 -47 -846 -288 -1093 -657 -110 -164 -197 -378 -238 -588 -27 -139 -24 -445 6 -585 101 -472 386 -853 792 -1059 222 -113 431 -163 679 -163 177 0 303 20 465 73 226 75 418 193 584 359 216 215 355 476 422 790 31 143 33 435 5 585 -90 484 -397 893 -827 1102 -243 119 -531 171 -795 143z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.39ff96e4.svg";
export { ForwardRef as ReactComponent };